import React from 'react'

export default function (propriedades) {
  return (
    <section className='banner'>
      <h1 className='titulo'><u>Reserve</u> seu Hotel</h1>
    </section>
  )
}
